"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaEngineDispatchExtensions = void 0;
const IAgoraMediaEngineDispatch_1 = require("../binding/IAgoraMediaEngineDispatch");
const IAgoraMediaEngineImpl_1 = require("../impl/IAgoraMediaEngineImpl");
class MediaEngineDispatchExtensions extends IAgoraMediaEngineDispatch_1.IMediaEngineDispatch {
    constructor(engine) {
        super(engine);
        this._impl = new IAgoraMediaEngineImpl_1.IMediaEngineImpl(engine);
    }
    unregisterAudioFrameObserver(apiParam) {
        let obj = JSON.parse(apiParam.data);
        let observer = obj.observer;
        if (observer === undefined)
            throw 'observer is undefined';
        return this._impl.unregisterAudioFrameObserver(observer);
    }
}
exports.MediaEngineDispatchExtensions = MediaEngineDispatchExtensions;
